module.exports = __webpack_public_path__ + "img/home_prj_hlhkzxt.13ba4e6c.jpg";